import React from "react";
const MainLayout = ({ children, ...rest }) => {
   return (
      <div>
        {children}
      </div>
   );
};
export default MainLayout;